// Application configuration based on environment
const ENV = process.env.REACT_APP_ENV || 'development';
const VERSION = process.env.REACT_APP_VERSION || 'internal';

const config = {
  development: {
    apiUrl: 'http://localhost:5000',
    version: 'internal',
    auth: {
      googleOAuth: true,
      emailPassword: false
    },
    limits: {
      storageLimit: null, // No limit for development
    },
    features: {
      feedbackModal: false,
      adminFeatures: true,
      alphaAccessRequest: false
    }
  },
  
  internal: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://digitables-backend.onrender.com',
    version: 'internal',
    auth: {
      googleOAuth: true,
      emailPassword: false
    },
    limits: {
      storageLimit: null, // Unlimited for internal team
    },
    features: {
      feedbackModal: false,
      adminFeatures: true,
      alphaAccessRequest: false
    }
  },
  
  alpha: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://digitables-backend.onrender.com',
    version: 'alpha',
    auth: {
      googleOAuth: false,
      emailPassword: true
    },
    limits: {
      storageLimit: 100 * 1024 * 1024, // 100MB in bytes
    },
    features: {
      feedbackModal: true,
      adminFeatures: false,
      alphaAccessRequest: true
    }
  }
};

// Determine which config to use
const getConfig = () => {
  // VERSION takes priority over ENV
  if (VERSION === 'alpha') return config.alpha;
  if (VERSION === 'internal') return config.internal;

  // Fallback to ENV-based selection
  if (ENV === 'development') return config.development;
  return config.internal;
};

// Export the current environment config
export const appConfig = getConfig();

// Helper functions
export const isAlphaVersion = () => appConfig.version === 'alpha';
export const isInternalVersion = () => appConfig.version === 'internal';
export const isDevelopment = () => ENV === 'development';

export const hasFeature = (feature) => appConfig.features[feature];
export const getLimit = (limit) => appConfig.limits[limit];
export const getAuthConfig = () => appConfig.auth;

// Storage helpers
export const formatBytes = (bytes, decimals = 2) => {
  if (!bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getStoragePercentage = (used, limit) => {
  if (!limit) return 0;
  return Math.min((used / limit) * 100, 100);
};

export default appConfig;